// import { BASE_URL_V3 } from "./config";

export const TenderPDFFolder = `wapi/docdownloadtender/`;
export const NoticePDFFolder = `wapi/docdownloadnoti/`;

export const FinancePDFFolder = `wapi/docdownloadfinance/`;
export const PaddyPDFFolder = `wapi/docdownloadpaddy/`;
export const FormPDFFolder = `wapi/docdownloadannoun/`;

// export const ADDRESSES = {
//   LOGIN: `${BASE_URL_V3}/auth/login`,
//   VEHICLES_LIST: `${BASE_URL_V3}/vehicle/list`,
//   GENERAL_SETTINGS: `${BASE_URL_V3}/master/general_settings`,
// };


